import tokens from '../tokens/js/tokens';
// Functions.
// -----------------------------------------------------------------------------
// Returns the value of the space token received as a parameter.
export const getSpace = (size) => !size ? '0px' : tokens.spacing[size].value;
// Returns the value of the radius token received as a parameter.
export const getRadius = (size) => !size ? '0px' : tokens.radius[size];
//# sourceMappingURL=space.utils.js.map